import { render } from "./PalworldView.vue?vue&type=template&id=0c2bd3fa"
import script from "./PalworldView.vue?vue&type=script&lang=js"
export * from "./PalworldView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__